import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FairnessFormGroup, useSelectedResultInfoStore } from '@pascal/pascal-core';
import { CARDS_TYPE, UNKNOWN_CARD_TYPE } from '../../enums/cardTypes';
import { AboutHash } from '../aboutHashComp/aboutHash';

export const CheckHashPopup = observer(() => {
  const {
    selectedResultInfo: { card },
  } = useSelectedResultInfoStore();
  const scrollRef = useRef(null);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setToggle(false);
  }, []);

  useEffect(() => {
    if (toggle && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
  }, [toggle]);

  return (
    <div className='hash-code-wrp'>
      <div className='fairness-cards'>
        <div
          className={`fairness-card ${
            card === UNKNOWN_CARD_TYPE ? 'backside-1' : `card-deck-1 ${CARDS_TYPE[card]}`
          }`}
        />
        {/* add class  backside-(1 - 4), calode-1, card-(As) */}
      </div>
      <div className='bc-forms-holder'>
        <FairnessFormGroup isShowCopyIcon isCheckResult isShowAboutHash aboutHashComp={AboutHash} />
      </div>
    </div>
  );
});
